<template>
    <div
        :class="[
            {
                'has-inline-label': hasInlineLabel,
            },
            parentClass,
            'form-group',
        ]"
    >
        <label
            :for="uniqueId"
            class="form-label move-label-to-top"
        >
            {{ label }}
        </label>
        <div class="input-group">
            <slot
                v-if="$slots.prepend"
                name="prepend"
            />
            <select
                v-model="inputValue"
                v-bind="$attrs"
                @change="handleChange"
                :id="uniqueId"
                class="custom-select w-100 move-label-to-top"
            >
                <option
                    v-for="(option, index) in inputOptions"
                    :value="option.value"
                    :key="index"
                >
                    {{ option.label }}
                </option>
            </select>
            <slot
                v-if="$slots.append"
                name="append"
            />
        </div>
        <slot />
    </div>
</template>

<script>
    import Config from '../../config';

    export default {
        name: 'FormInput',
        inheritAttrs: false,
        props: {
            value: {
                type: [String, Number],
                default: '',
            },
            type: {
                type: String,
                default: 'text',
            },
            label: {
                required: true,
                type: String,
            },
            parentClass: {
                type: String,
                default: '',
            },
            inlineLabel: {
                type: Boolean,
                default: Config.options.inlineLabel,
            },
            options: {
                required: true,
                type: Array,
            },
            sort: {
                type: Boolean,
                default: false,
            },
            sortType: {
                type: String,
                default: 'ASC',
                validate: value => ['ASC', 'DESC'].includes(value),
            },
            sortKey: {
                type: String,
                default: 'label',
            },
        },
        data() {
            return {
                focus: false,
                inputValue: null,
                hasInlineLabel: this.inlineLabel,
            };
        },
        computed: {
            uniqueId() {
                return this.$id('pacos-select');
            },
            inputOptions() {
                if (this.sort) return this.sortedOptions;

                return this.options;
            },
            sortedOptions() {
                let sorted = this.options
                    .filter(({ value }) => value !== '')
                    .sort((a, b) => a[this.sortKey].localeCompare(b[this.sortKey]));

                if (this.sortType === 'DESC') {
                    sorted = sorted.reverse();
                }

                return [
                    this.options.find(({ value }) => value === ''),
                    ...sorted,
                ];
            },
        },
        methods: {
            handleChange() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.inputValue = value;
                },
            },
        },
    };
</script>
